import { render, staticRenderFns } from "./x-filter.component.vue?vue&type=template&id=677195bf&scoped=true"
import script from "./x-filter.component.vue?vue&type=script&lang=ts"
export * from "./x-filter.component.vue?vue&type=script&lang=ts"
import style0 from "./x-filter.component.vue?vue&type=style&index=0&id=677195bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677195bf",
  null
  
)

export default component.exports